import numeral from 'numeral';

const keys = [
    {
        key: 'clicks',
        label: 'Avg. Clicks',
        icon: 'clicks',
        yAxisID: 'y3',
    },
    {
        key: 'impressions',
        label: 'Avg. Impressions',
        icon: 'search',
    },
    {
        key: 'avgPosition',
        label: 'Avg. Position',
        icon: 'pagev-view',
        yAxisID: 'y1',
    },
    {
        key: 'avgCTR',
        label: 'Avg. CTR',
        format: '0.00%',
        yAxisID: 'y1',
        render: (data) => numeral(data * 100).format('0.00'),
        icon: 'ctr',
    },
    {
        key: 'urls',
        label: 'URLs',
        icon: 'pagev-view',
        type: 'bar',
        yAxisID: 'y1',
        hidden: true,
    },
    {
        key: 'weekly_keywords',
        label: 'Avg. Keywords',
        icon: 'pagev-view',
        type: 'bar',
        yAxisID: 'y1',
        hidden: true,
    },
];

export default keys;
